import { withTranslation } from 'react-i18next';
import { Component } from 'react';

class ShowAll extends Component {
    constructor(props) {
        super(props);

        this.onClickShowAll = this.onClickShowAll.bind(this);
        this.state = {
            showTwo: props.data.length > 2,
        };
    }

    onClickShowAll = () => {
        this.setState({ showTwo: false });
    };

    render() {
        const { t } = this.props;
        const { showTwo } = this.state;

        const firstTwo = this.props.data.slice(0, 2);
        const data = showTwo ? firstTwo : this.props.data;

        return (
            <div
                className={`d-flex flex-column gap-12 ai-tracking-prompts-cell ${
                    showTwo ? 'show-two' : ''
                }`}
            >
                {data.map((item, index) => (
                    <div className="ai-tracking-projects-platforms text-wrap" key={index}>
                        {item}
                    </div>
                ))}
                {showTwo && (
                    <div className="ai-tracking-prompts-show-all">
                        <button onClick={this.onClickShowAll}>
                            <i className="icon-arrow-down" />{' '}
                            {t('ai_tracking.prompt_generator.show_all')}
                        </button>
                    </div>
                )}
            </div>
        );
    }
}

export default withTranslation()(ShowAll);
